<!-- ══════════════════ Line & Area builder ══════════════════
     Mirrors the Bar builder: a family card (variant picker), a Chart-Data
     accordion (X / Series / Secondary-Y pickers + N measures + reference
     lines), then the config-driven Format accordions. Renders client-side. -->
<div class="wf-section wf-section-plain" *ngIf="active">
  <ng-container *ngTemplateOutlet="datasetPicker"></ng-container>
  <small class="control-warning" *ngIf="host.drillColumnsErrorMessage">{{ host.drillColumnsErrorMessage }} (see console for details)</small>

  <div class="bridge-chart-settings bar-family-card">
    <div class="bridge-settings-heading"><mat-icon>show_chart</mat-icon><span>{{ host.layoutSectionTitle('lineArea', 'Line & area') }}</span></div>
    <small class="control-hint" *ngIf="host.layoutSectionHint('lineArea')">{{ host.layoutSectionHint('lineArea') }}</small>

    <div class="control-group">
      <label>Variant</label>
      <ng-select
        #ssLaVariant
        class="ss-select"
        [class.is-open]="!!ssLaVariant.isOpen?.()"
        appendTo="body"
        ngClass="ss-dropdown-panel"
        [items]="lineAreaVariants"
        bindLabel="label"
        bindValue="value"
        groupBy="group"
        [clearable]="true"
        [ngModel]="laVariant"
        (ngModelChange)="laVariant = $event ?? ''; onLineAreaChange()"
      ></ng-select>
      <small class="control-hint wf-variant-hint" *ngIf="laVariantHint">{{ laVariantHint }}</small>
    </div>
  </div>

  <!-- ══ Chart Data accordion ══ -->
  <div class="bar-options-accordion">
    <div class="dvm-format-group is-open">
      <div class="dvm-format-group-head" style="cursor: default;">
        <span>Chart Data</span>
      </div>
      <div class="dvm-format-group-body">

        <div class="control-row">
          <!-- Category = the X axis. -->
          <div class="control-group wf-field-drop-zone" (dragover)="host.allowFieldDrop($event)" (drop)="onLaCategoryFieldDrop($event)" title="Drag a column here">
            <label>X axis <span class="wf-axis-hint">— group by</span></label>
            <ng-select
              #ssLaCategory class="ss-select" [class.is-open]="!!ssLaCategory.isOpen?.()" appendTo="body" ngClass="ss-dropdown-panel"
              [items]="host.builderColumns" [clearable]="true" [searchable]="true" [loading]="host.isDrillDatasetColumnsLoading" [disabled]="!host.drillDataset"
              [placeholder]="host.columnPlaceholder()" [ngModel]="laCategory || null" (ngModelChange)="laCategory = $event || ''; onLineAreaChange()"
            ></ng-select>
          </div>
          <!-- Series split — REQUIRED for Multi-Line / Stacked Area / 100%. -->
          <div class="control-group wf-field-drop-zone" [class.is-required-empty]="laSeriesRequired && !laSeries" *ngIf="laVariantUsesSeries" (dragover)="host.allowFieldDrop($event)" (drop)="onLaSeriesFieldDrop($event)" title="Drag a column here">
            <label>Split / Legend <span class="wf-axis-hint">{{ laSeriesRequired ? '(required)' : '(optional)' }}</span></label>
            <ng-select
              #ssLaSeries class="ss-select" [class.is-open]="!!ssLaSeries.isOpen?.()" appendTo="body" ngClass="ss-dropdown-panel"
              [items]="host.builderColumns" [clearable]="!laSeriesRequired" [searchable]="true" [loading]="host.isDrillDatasetColumnsLoading" [disabled]="!host.drillDataset"
              [placeholder]="laSeriesRequired ? 'Pick a column to split by' : host.columnPlaceholder()" [ngModel]="laSeries || null" (ngModelChange)="laSeries = $event || ''; onLineAreaChange()"
            ></ng-select>
          </div>
        </div>

        <!-- Secondary axes — ALWAYS shown. Secondary X = a second category
             column on a top X-axis (its own series); Secondary Y = dual value axis. -->
        <div class="control-row">
          <div class="control-group wf-field-drop-zone" (dragover)="host.allowFieldDrop($event)" (drop)="onLaSecondaryXFieldDrop($event)" title="Drag a column here">
            <label>Secondary X-axis <span class="wf-axis-hint">(category)</span></label>
            <ng-select
              #ssLaSecX class="ss-select" [class.is-open]="!!ssLaSecX.isOpen?.()" appendTo="body" ngClass="ss-dropdown-panel"
              [items]="host.builderColumns" [clearable]="true" [searchable]="true" [loading]="host.isDrillDatasetColumnsLoading" [disabled]="!host.drillDataset"
              [placeholder]="host.columnPlaceholder()" [ngModel]="laSecondaryXField || null" (ngModelChange)="laSecondaryXField = $event || ''; onLineAreaChange()"
            ></ng-select>
          </div>
          <div class="control-group wf-field-drop-zone" (dragover)="host.allowFieldDrop($event)" (drop)="onLaSecondaryYFieldDrop($event)" title="Drag a column here">
            <label>Secondary Y-axis <span class="wf-axis-hint">(values — dual)</span></label>
            <ng-select
              #ssLaSecY class="ss-select" [class.is-open]="!!ssLaSecY.isOpen?.()" appendTo="body" ngClass="ss-dropdown-panel"
              [items]="host.builderColumns" [clearable]="true" [searchable]="true" [loading]="host.isDrillDatasetColumnsLoading" [disabled]="!host.drillDataset"
              [placeholder]="host.columnPlaceholder()" [ngModel]="laSecondaryYField || null" (ngModelChange)="laSecondaryYField = $event || ''; onLineAreaChange()"
            ></ng-select>
          </div>
        </div>
        <!-- Value plotted against the secondary X axis (defaults to the first measure). -->
        <div class="control-row" *ngIf="laSecondaryXField">
          <div class="control-group">
            <label>Secondary X value <span class="wf-axis-hint">(defaults to first measure)</span></label>
            <ng-select
              #ssLaSecXVal class="ss-select" [class.is-open]="!!ssLaSecXVal.isOpen?.()" appendTo="body" ngClass="ss-dropdown-panel"
              [items]="host.builderColumns" [clearable]="true" [searchable]="true" [loading]="host.isDrillDatasetColumnsLoading" [disabled]="!host.drillDataset"
              [placeholder]="host.columnPlaceholder()" [ngModel]="laSecondaryXValueField || null" (ngModelChange)="laSecondaryXValueField = $event || ''; onLineAreaChange()"
            ></ng-select>
          </div>
          <div class="control-group">
            <label>Secondary X position</label>
            <ng-select
              class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="laSecondaryXPositions" bindLabel="label" bindValue="value"
              [clearable]="true" [searchable]="false" [ngModel]="laSecondaryXPosition" (ngModelChange)="laSecondaryXPosition = $event ?? ''; onLineAreaChange()"
            ></ng-select>
          </div>
        </div>

        <!-- Axis labels — override the auto-derived axis titles (column /
             measure names). Blank = auto. The Format Axis accordion's
             titles still win when set there. CONFIG-DRIVEN: each input
             exists/relabels via its layoutSteps entry in line-area.json
             (fields categoryLabel / yAxisLabel / xAxisLabel2 / yAxisLabel2). -->
        <div class="control-row" *ngIf="host.fieldEnabled('lineArea', 'categoryLabel') || host.fieldEnabled('lineArea', 'yAxisLabel')">
          <div class="control-group" *ngIf="host.fieldEnabled('lineArea', 'categoryLabel')">
            <label>{{ host.fieldLabel('lineArea', 'categoryLabel', 'X axis label') }}</label>
            <input type="text" [ngModel]="laCategoryLabel" (ngModelChange)="laCategoryLabel = $event; onLineAreaChange()" [placeholder]="laCategory || 'Auto'" />
          </div>
          <div class="control-group" *ngIf="host.fieldEnabled('lineArea', 'yAxisLabel')">
            <label>{{ host.fieldLabel('lineArea', 'yAxisLabel', 'Y axis label') }}</label>
            <input type="text" [ngModel]="laYAxisLabel" (ngModelChange)="laYAxisLabel = $event; onLineAreaChange()" placeholder="Auto — first measure" />
          </div>
        </div>
        <div class="control-row" *ngIf="(laSecondaryXField && host.fieldEnabled('lineArea', 'xAxisLabel2')) || (laHasSecondaryY && host.fieldEnabled('lineArea', 'yAxisLabel2'))">
          <div class="control-group" *ngIf="laSecondaryXField && host.fieldEnabled('lineArea', 'xAxisLabel2')">
            <label>{{ host.fieldLabel('lineArea', 'xAxisLabel2', 'Secondary X axis label') }}</label>
            <input type="text" [ngModel]="laSecondaryXLabel" (ngModelChange)="laSecondaryXLabel = $event; onLineAreaChange()" [placeholder]="laSecondaryXField || 'Auto'" />
          </div>
          <div class="control-group" *ngIf="laHasSecondaryY && host.fieldEnabled('lineArea', 'yAxisLabel2')">
            <label>{{ host.fieldLabel('lineArea', 'yAxisLabel2', 'Secondary Y axis label') }}</label>
            <input type="text" [ngModel]="laSecondaryYLabel" (ngModelChange)="laSecondaryYLabel = $event; onLineAreaChange()" placeholder="Auto — secondary measure" />
          </div>
        </div>

        <!-- Per-axis label FONT WEIGHTS — highlight an axis's tick labels +
             title independently. '' = default (falls back to the Format
             popup's tile-wide "Axis label weight"). CONFIG-DRIVEN via
             layoutSteps entries in line-area.json; options from the shared
             shell `fontWeights` list. Secondary rows only show once the
             matching secondary axis is mapped. -->
        <div class="control-row" *ngIf="host.fieldEnabled('lineArea', 'xAxisFontWeight') || host.fieldEnabled('lineArea', 'yAxisFontWeight')">
          <div class="control-group" *ngIf="host.fieldEnabled('lineArea', 'xAxisFontWeight')">
            <label>{{ host.fieldLabel('lineArea', 'xAxisFontWeight', 'X axis label weight') }}</label>
            <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="host.fontWeightOptions" bindLabel="label" bindValue="value" [clearable]="true" [searchable]="false" [ngModel]="laXAxisFontWeight" (ngModelChange)="laXAxisFontWeight = $event ?? ''; onLineAreaChange()"></ng-select>
          </div>
          <div class="control-group" *ngIf="host.fieldEnabled('lineArea', 'yAxisFontWeight')">
            <label>{{ host.fieldLabel('lineArea', 'yAxisFontWeight', 'Y axis label weight') }}</label>
            <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="host.fontWeightOptions" bindLabel="label" bindValue="value" [clearable]="true" [searchable]="false" [ngModel]="laYAxisFontWeight" (ngModelChange)="laYAxisFontWeight = $event ?? ''; onLineAreaChange()"></ng-select>
          </div>
        </div>
        <div class="control-row" *ngIf="(laSecondaryXField && host.fieldEnabled('lineArea', 'xAxis2FontWeight')) || (laHasSecondaryY && host.fieldEnabled('lineArea', 'yAxis2FontWeight'))">
          <div class="control-group" *ngIf="laSecondaryXField && host.fieldEnabled('lineArea', 'xAxis2FontWeight')">
            <label>{{ host.fieldLabel('lineArea', 'xAxis2FontWeight', 'Secondary X axis label weight') }}</label>
            <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="host.fontWeightOptions" bindLabel="label" bindValue="value" [clearable]="true" [searchable]="false" [ngModel]="laSecondaryXFontWeight" (ngModelChange)="laSecondaryXFontWeight = $event ?? ''; onLineAreaChange()"></ng-select>
          </div>
          <div class="control-group" *ngIf="laHasSecondaryY && host.fieldEnabled('lineArea', 'yAxis2FontWeight')">
            <label>{{ host.fieldLabel('lineArea', 'yAxis2FontWeight', 'Secondary Y axis label weight') }}</label>
            <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="host.fontWeightOptions" bindLabel="label" bindValue="value" [clearable]="true" [searchable]="false" [ngModel]="laSecondaryYFontWeight" (ngModelChange)="laSecondaryYFontWeight = $event ?? ''; onLineAreaChange()"></ng-select>
          </div>
        </div>

        <!-- Measures = the value axis. Each row: column + draw-as + axis (+ reorder). -->
        <div class="wf-subsection-header">
          <span>Y values <span class="wf-axis-hint">— measures</span> <span class="wf-step-count">{{ laMeasures.length }}</span></span>
          <button type="button" class="add-step-button" mat-stroked-button *ngIf="laAllowsMultipleMeasures" (click)="addLaMeasure()"><mat-icon>add</mat-icon> Add measure</button>
        </div>
        <small class="control-hint" *ngIf="laVariantUsesSeries && laSeries">Series split active — the first measure supplies the value.</small>

        <div class="wf-field-drop-zone bar-measures-zone" (dragover)="host.allowFieldDrop($event)" (drop)="onLaMeasureFieldDrop($event)">
          <div class="wf-empty" *ngIf="!laMeasures.length">No measures yet — add one, or drag a column here.</div>
          <div class="bar-measure-row" *ngFor="let measure of laMeasures; let i = index; let first = first; let last = last">
            <div class="control-row">
              <div class="control-group wf-field-drop-zone" (dragover)="host.allowFieldDrop($event)" (drop)="onLaMeasureFieldDrop($event, measure)" title="Drag a column here">
                <label>Column</label>
                <ng-select
                  class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="host.builderColumns" [clearable]="true" [searchable]="true"
                  [loading]="host.isDrillDatasetColumnsLoading" [disabled]="!host.drillDataset" [placeholder]="host.columnPlaceholder()"
                  [ngModel]="measure.field || null" (ngModelChange)="measure.field = $event || ''; onLaMeasureChange()"
                ></ng-select>
              </div>
              <div class="control-group">
                <label>Label</label>
                <input type="text" [ngModel]="measure.label" (ngModelChange)="measure.label = $event; onLaMeasureChange()" [placeholder]="measure.field || 'Measure'" />
              </div>
            </div>
            <div class="control-row">
              <div class="control-group" *ngIf="!(laVariantUsesSeries && laSeries)">
                <label>Draw as</label>
                <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="lineAreaRenderTypes" bindLabel="label" bindValue="value" [clearable]="true" [ngModel]="measure.renderAs" (ngModelChange)="measure.renderAs = $event ?? ''; onLaMeasureChange()"></ng-select>
              </div>
              <div class="control-group" *ngIf="!(laVariantUsesSeries && laSeries)">
                <label>Axis</label>
                <ng-select class="ss-select" appendTo="body" ngClass="ss-dropdown-panel" [items]="lineAreaAxisOptions" bindLabel="label" bindValue="value" [clearable]="true" [ngModel]="measure.axis" (ngModelChange)="measure.axis = $event ?? ''; onLaMeasureChange()"></ng-select>
              </div>
              <!-- Line colour for THIS measure. Blank = take the palette
                   slot, so the swatch shows the colour actually in use and
                   the reset arrow puts it back. Hidden under a series split,
                   where lines come from the split's values, not measures. -->
              <div class="control-group bar-measure-color" *ngIf="!(laVariantUsesSeries && laSeries)">
                <label>Line color</label>
                <div class="la-measure-color-row">
                  <input
                    type="color"
                    [ngModel]="laMeasureColor(measure, i)"
                    (ngModelChange)="measure.color = $event; onLaMeasureChange()"
                    [title]="measure.color ? 'Line color' : 'Palette default — pick to override'"
                  />
                  <button
                    type="button"
                    mat-icon-button
                    class="la-measure-color-reset"
                    *ngIf="measure.color"
                    (click)="measure.color = ''; onLaMeasureChange()"
                    matTooltip="Reset to palette color"
                  ><mat-icon>restart_alt</mat-icon></button>
                </div>
              </div>
              <div class="control-group" *ngIf="!(laVariantUsesSeries && laSeries)">
                <label>Data point shape</label>
                <ng-select
                  class="ss-select" appendTo="body" ngClass="ss-dropdown-panel"
                  [items]="lineAreaSymbolOptions" bindLabel="label" bindValue="value"
                  [clearable]="true" [searchable]="false"
                  [ngModel]="measure.symbol || 'circle'"
                  (ngModelChange)="onLaMeasureSymbolChange(measure, $event)"
                ></ng-select>
              </div>
              <div class="control-group" *ngIf="!(laVariantUsesSeries && laSeries)">
                <label>Point size (px)</label>
                <input
                  type="number" min="0" max="24" step="1"
                  [ngModel]="measure.symbolSize ?? 6"
                  (ngModelChange)="onLaMeasureSymbolSizeChange(measure, $event)"
                  title="Set this line's data point size in pixels"
                />
              </div>
              <div class="control-group bar-measure-actions" *ngIf="laAllowsMultipleMeasures && laMeasures.length > 1">
                <button type="button" mat-icon-button (click)="moveLaMeasureUp(i)" [disabled]="first" matTooltip="Move up"><mat-icon>arrow_upward</mat-icon></button>
                <button type="button" mat-icon-button (click)="moveLaMeasureDown(i)" [disabled]="last" matTooltip="Move down"><mat-icon>arrow_downward</mat-icon></button>
                <button type="button" mat-icon-button class="row-remove-button" (click)="removeLaMeasure(measure)" matTooltip="Remove measure"><mat-icon>close</mat-icon></button>
              </div>
            </div>
          </div>
        </div>

        <!-- Reference / target lines. -->
        <div class="wf-subsection-header">
          <span>Reference lines <span class="wf-step-count">{{ laReferenceLines.length }}</span></span>
          <button type="button" class="add-step-button" mat-stroked-button (click)="addLaReferenceLine()"><mat-icon>add</mat-icon> Add line</button>
        </div>
        <div class="bar-refline-list" *ngIf="laReferenceLines.length">
          <div class="control-row bar-refline-row" *ngFor="let line of laReferenceLines">
            <div class="control-group">
              <label>Value</label>
              <input type="number" [ngModel]="line.value" (ngModelChange)="line.value = $event; onLaReferenceLineChange()" placeholder="e.g. 100" />
            </div>
            <div class="control-group">
              <label>Label</label>
              <input type="text" [ngModel]="line.label" (ngModelChange)="line.label = $event; onLaReferenceLineChange()" placeholder="Target" />
            </div>
            <div class="control-group bar-refline-color">
              <label>Color</label>
              <input type="color" [ngModel]="line.color" (ngModelChange)="line.color = $event; onLaReferenceLineChange()" />
            </div>
            <button type="button" mat-icon-button class="bar-refline-remove row-remove-button" (click)="removeLaReferenceLine(line.id)" matTooltip="Remove line"><mat-icon>close</mat-icon></button>
          </div>
        </div>

      </div><!-- /Chart Data body -->
    </div>
  </div>

  <!-- Line & Area options — Title / Axis / Legend / Labels / Tooltip / Formatting /
       Analytics / Interaction / Advanced accordions (shared template). -->
  <ng-container [ngTemplateOutlet]="chartFormatAccordion"></ng-container>
</div>
